import React, { useEffect, useRef } from 'react';
import grapesjs from 'grapesjs';
import 'grapesjs/dist/css/grapes.min.css';

export default function GrapesEditor({ htmlCss, setHtmlResult }) {
  const editorRef = useRef(null);
  const grapesEditor = useRef(null);

  useEffect(() => {
    if (!editorRef.current) return;

    // If already initialized, destroy before re-init to avoid duplicates
    if (grapesEditor.current) {
      grapesEditor.current.destroy();
    }

    grapesEditor.current = grapesjs.init({
      container: editorRef.current,
      fromElement: false,
      height: '600px',
      width: '100%',
      storageManager: false, // disable storage for now
      components: htmlCss || '<div>Your HTML will appear here</div>',
      style: '',
      // You can add plugins or custom blocks here if you want
    });
    
    // Cleanup on unmount
    return () => grapesEditor.current && grapesEditor.current.destroy();
  }, [htmlCss]);

  useEffect(() => {
    if (grapesEditor.current) {
      grapesEditor.current.on('update', () => {
        const html = grapesEditor.current.getHtml();
        const css = grapesEditor.current.getCss();
        // You can send back combined or separate html & css here

        const fullHtml = `
        <!DOCTYPE html>
        <html>
            <head>
            <style>${css}</style>
            </head>
            <body>${html}</body>
        </html>`.trim();

        // setHtmlResult(fullHtml);
        console.log('Updated HTML:', html);
      });
    }
  }, []);

  return (
    <div>
      <div ref={editorRef} />
    </div>
  );
}
